import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5a37117a")

_pushScopeId("data-v-5a37117a")
const _hoisted_1 = {
  class: "ui__soakWater_main",
  id: "SoakWater"
}
const _hoisted_2 = { class: "ui__soakWater_body" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "ui__line_main" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_componentTitle = _resolveComponent("componentTitle")
  const _component_defectList = _resolveComponent("defectList")

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_componentTitle, {
        title: _ctx.state.titleText,
        data: _ctx.state.titleData,
        listSumNumber: _ctx.state.listSumNumber
      }, null, 8, ["title", "data", "listSumNumber"]),
      (_ctx.state.defectList.length > 0)
        ? (_openBlock(), _createBlock(_component_defectList, {
            key: 0,
            defectData: _ctx.state
          }, null, 8, ["defectData"]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_3
  ], 512)), [
    [_vShow, _ctx.state.reportLevel !== 4 && _ctx.state.defectList.length > 0]
  ])
})